import { ListOption } from '../models';

export const NOTIFICATIONS: readonly ListOption[] = [
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.NOTIFICATION_EMPTY',
    value: '0',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.NOTIFICATION_SIMPLE',
    value: '1',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.NOTIFICATION_ORDERED',
    value: '2',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.NOTIFICATION_EMAIL',
    value: '5',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.NOTIFICATION_SMS',
    value: '7',
  },
];

export const NOTIFICATIONS_MAP = new Map<string, string>(
  NOTIFICATIONS.map((item) => [item.value, item.label]) as any
);

export const OBTAINING_METHODS = [
  {
    label: 'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.VIA_VIBER_OR_SMS',
    value: '0',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.CREATE_MODAL.BY_E-MAIL',
    value: '1',
  },
];
